/* eslint-disable */

import React from 'react';

import { ScrollView, StyleSheet, View, Platform } from 'react-native';
import Swiper from 'react-native-swiper';
import PagerView from 'react-native-pager-view';

let styles = StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    position: 'relative',
  },

  wrapper: {
    backgroundColor: 'transparent',
  },

  slide: {
    backgroundColor: 'transparent',
  },
});

export default class SwiperWrapper extends Swiper {
  renderScrollView1(pages) {
    if (Platform.OS === 'ios')
      return (
        <ScrollView
          ref="scrollView"
          {...this.props}
          contentContainerStyle={[styles.wrapper, this.props.style]}
          contentOffset={this.state.offset}
          onScrollBeginDrag={this.onScrollBegin}
          onMomentumScrollEnd={this.onScrollEnd}
          onScroll={this.onScroll}
          scrollEventThrottle={16}
        >
          {pages}
        </ScrollView>
      );
    return (
      <PagerView
        ref="scrollView"
        {...this.props}
        initialPage={this.state.index}
        onPageSelected={this.onScrollEnd}
        style={{ flex: 1 }}
        onPageScroll={this.onAndroidScroll}
      >
        {pages}
      </PagerView>
    );
  }
  render() {
    let state = this.state;
    let props = this.props;
    let children = props.children;
    let index = state.index;
    let total = state.total;
    let loop = props.loop;
    let dir = state.dir;
    let key = 0;

    let pages = [];
    let pageStyle = [{ width: state.width, height: state.height }, styles.slide];

    // For make infinite at least total > 1
    if (total > 1) {
      // Re-design a loop model for avoid img flickering
      pages = Object.keys(children);
      if (loop) {
        pages.unshift(total - 1);
        pages.push(0);
      }

      pages = pages.map((page, i) => (
        <View style={pageStyle} key={i}>
          {children[page]}
        </View>
      ));
    } else pages = <View style={pageStyle}>{children}</View>;

    return (
      <View
        style={[
          styles.container,
          {
            width: state.width,
            height: state.height,
          },
        ]}
      >
        {this.renderScrollView1(pages)}
        {props.showsPagination &&
          (props.renderPagination
            ? this.props.renderPagination(state.index, state.total, this)
            : this.renderPagination())}
        {this.renderTitle()}
        {this.props.showsButtons && this.renderButtons()}
      </View>
    );
  }
}
